<template>
  <div v-if="this.$store.getters['authorization/acl'].hasPermission('blacklist_access')"
       class="PlatformBlacklistView"
  >
    <ShPageHeader :breadcrumb-items="[
                    { label: 'zarządzanie' },
                    { label: 'czarna lista', path: '/blacklist' }
                  ]"
                  :description="`Lista wszystkich zablokowanych numerów`"
                  title="Czarna lista numerów"
    />
    <BlacklistFilters :project-list="projectsList" />
    <Blacklist :blacklist="blacklist"
               @openCreationFormModal="toggleCreationFormModal"
    />
    <ShSideBarModal
      :description="'Uzupełnij poniższy formularz aby dodać nowy numer do czarnej listy'"
      :side-bar-modal-visibility.sync="isSideBarModalVisibility"
      :title="'Formularz przypisywania nowego numeru'"
      @closeModal="toggleCreationFormModal"
    >
      <BlacklistOperationForm slot="content"
                              :project-list="projectsList"
                              @closeModal="toggleCreationFormModal"
                              @refreshList="getBlacklist"
      />
    </ShSideBarModal>
  </div>
</template>

<script>

import { hDeepCopy } from '@/utils/helpers';
import BlacklistFilters from '../components/Blacklist/BlacklistFilters';
import Blacklist from '../components/Blacklist/Blacklist';
import BlacklistOperationForm from '../components/Blacklist/BlacklistOperationForm';

export default {
  name: 'PlatformBlacklist',
  components: {
    BlacklistFilters,
    Blacklist,
    BlacklistOperationForm,
  },

  data() {
    return {
      isSideBarModalVisibility: false,
    };
  },

  computed: {
    projectsList() {
      return this.$store.getters['client/projects/list'].records;
    },
    userData() {
      return this.$store.getters['authorization/user'];
    },
    blacklist() {
      return hDeepCopy(this.$store.getters['blacklist/list']);
    },
  },

  async created() {
    await this.getBlacklist();
    await this.$store.dispatch('client/projects/getList', this.userData.client.uuid);
  },

  methods: {
    async getBlacklist() {
      this.$store.dispatch('blacklist/clearFilteringCriteria');
      await this.$store.dispatch('blacklist/getList');
    },
    toggleCreationFormModal() {
      this.isSideBarModalVisibility = !this.isSideBarModalVisibility;
    },
  },
};
</script>

<style lang="sass" scoped>
.PlatformBlacklistView
  margin: 20px

</style>
